import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/companies/successfullAddCompanyDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddCompany_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddCompany_action_icon' />
        <Typography className='SuccessfulAddCompany_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfulAddConpanyDialog = ({ openSuccessfulAddCompany, setOpenSuccessfulAddCompany, setOpenAddCompany, companyId }) => {

    const navigate = useNavigate();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddCompany(false);
        setOpenAddCompany(true);
    }, [setOpenAddCompany, setOpenSuccessfulAddCompany]);

    const handleNavigateToCompanyPage = useCallback(() => {
        navigate(`entreprise_details/${companyId}`);
    }, [companyId, navigate]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddCompany(false);
    }, [setOpenSuccessfulAddCompany]);

    return (
        <Dialog open={openSuccessfulAddCompany} onClose={handleClose} classes={{ paper: 'SuccessfulAddCompany_dialog' }} fullWidth>
            <IconButton onClick={handleClose} className='SuccessfulAddCompany_icon_button'>
                <Iconify icon="material-symbols:close" className='SuccessfulAddCompany_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddCompany_dialog_content' >
                <Iconify icon="lets-icons:check-ring-light" className='SuccessfulAddCompany_check_icon' />
                <Typography className='SuccessfulAddCompany_message'>Ajouté avec succès !</Typography>
                <Box className='SuccessfulAddCompany_action_container'>
                    <ActionBox
                        icon="pepicons-pop:file"
                        text="Page de l’entreprise "
                        onClick={handleNavigateToCompanyPage}
                    />
                    <ActionBox
                        icon="material-symbols-light:cards-outline"
                        text="Liste des entreprise"
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon="material-symbols-light:add"
                        text="Ajouter une entreprise"
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};